import axios, { AxiosError, AxiosRequestHeaders } from "axios";

export const newCapTableResetApi = axios.create({
  baseURL: process.env.REACT_APP_NEW_CAPTABLE_API || "http://localhost:4000",
});
